<template>
  <div class="ca-card" :class="{ 'ca-card-principal': address.principal === 1 }">

    <!-- Principal badge -->
    <div v-if="address.principal === 1" class="ca-principal-badge">
      <svg width="10" height="10" fill="none" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>
      Principal
    </div>

    <!-- Icon + Address -->
    <div class="ca-body">
      <div class="ca-icon">
        <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="10" r="3" stroke="currentColor" stroke-width="2"/></svg>
      </div>
      <div class="ca-address">
        <div class="ca-street">{{ address.user_rua }}, N° {{ address.user_nmr }}</div>
        <div class="ca-detail">{{ address.user_bairro }} — {{ address.user_cidade }}/{{ address.user_estado }}</div>
        <div v-if="address.user_complemento" class="ca-complement">{{ address.user_complemento }}</div>
      </div>
    </div>

    <!-- Actions -->
    <div class="ca-actions">
      <!-- Toggle principal -->
      <label class="ca-toggle-wrap" :title="address.principal === 1 ? 'Endereço principal' : 'Definir como principal'">
        <input
          type="checkbox"
          class="ca-toggle-input"
          :checked="address.principal === 1"
          @change="$emit('changePrincipal', address)"
        >
        <span class="ca-toggle"></span>
        <span class="ca-toggle-label">Principal</span>
      </label>

      <div class="ca-btns">
        <button class="ca-btn ca-btn-edit" title="Editar" @click="$emit('editAddress', address.id)">
          <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          Editar
        </button>
        <button class="ca-btn ca-btn-delete" title="Remover" @click="$emit('deleteAddress', address)">
          <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M19 6l-1 14H6L5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M10 11v6M14 11v6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          Remover
        </button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object, default: () => ({}) },
  },
  computed: {
    address: {
      get() { return this.value },
      set(v) { this.$emit('input', v) },
    },
  },
}
</script>

<style scoped>
.ca-card {
  background: var(--dk-bg-card-hover, #fafbfc);
  border: 1.5px solid var(--dk-border, #e5e8ef);
  border-radius: 14px;
  padding: 16px 18px;
  display: flex; flex-direction: column; gap: 12px;
  position: relative; transition: all 0.2s;
}
.ca-card:hover { box-shadow: 0 4px 16px rgba(13,51,73,0.07); }
.ca-card-principal {
  border-color: rgba(232,106,16,0.35);
  background: rgba(232,106,16,0.03);
}

/* Principal badge */
.ca-principal-badge {
  position: absolute; top: -10px; left: 14px;
  display: inline-flex; align-items: center; gap: 4px;
  padding: 3px 10px; border-radius: 20px;
  background: #E86A10; color: #fff;
  font-size: 10.5px; font-weight: 700;
}

/* Body */
.ca-body { display: flex; align-items: flex-start; gap: 12px; margin-top: 4px; }
.ca-icon {
  width: 38px; height: 38px; border-radius: 10px; flex-shrink: 0;
  background: rgba(13,51,73,0.07); color: var(--dk-text-primary, #0D3349);
  display: flex; align-items: center; justify-content: center;
}
.ca-card-principal .ca-icon { background: rgba(232,106,16,0.1); color: #E86A10; }
.ca-street { font-size: 14px; font-weight: 600; color: var(--dk-text-primary, #0D3349); }
.ca-detail { font-size: 12.5px; color: var(--dk-text-muted, #8a94a6); margin-top: 2px; }
.ca-complement { font-size: 12px; color: var(--dk-text-faint, #aab0bc); margin-top: 1px; }

/* Actions */
.ca-actions { display: flex; align-items: center; justify-content: space-between; border-top: 1px solid var(--dk-border-light, #f0f2f5); padding-top: 10px; }

/* Toggle */
.ca-toggle-wrap { display: flex; align-items: center; gap: 7px; cursor: pointer; }
.ca-toggle-input { display: none; }
.ca-toggle {
  width: 34px; height: 18px; border-radius: 10px;
  background: #dde1e8; position: relative; transition: background 0.2s; flex-shrink: 0;
}
.ca-toggle-input:checked + .ca-toggle { background: #E86A10; }
.ca-toggle::after {
  content: ''; position: absolute; top: 2px; left: 2px;
  width: 14px; height: 14px; border-radius: 50%; background: var(--dk-bg-card, #fff);
  transition: transform 0.2s; box-shadow: 0 1px 3px rgba(0,0,0,0.15);
}
.ca-toggle-input:checked + .ca-toggle::after { transform: translateX(16px); }
.ca-toggle-label { font-size: 12px; font-weight: 600; color: var(--dk-text-secondary, #6b7280); }

/* Buttons */
.ca-btns { display: flex; gap: 6px; }
.ca-btn {
  display: flex; align-items: center; gap: 5px;
  padding: 5px 12px; border-radius: 7px; border: none; cursor: pointer;
  font-size: 12.5px; font-weight: 600; transition: all 0.15s;
}
.ca-btn-edit { background: rgba(13,51,73,0.07); color: var(--dk-text-primary, #0D3349); }
.ca-btn-edit:hover { background: rgba(13,51,73,0.13); }
.ca-btn-delete { background: rgba(193,43,43,0.07); color: #C12B2B; }
.ca-btn-delete:hover { background: rgba(193,43,43,0.14); }
</style>
